import React, { useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import BackButton from "../atoms/buttons/BackButton";
import NextButton from "../atoms/buttons/NextButton";
import AppRoutes from "../config/AppRoutes";
import CustomNav from "../ui/nav/CustomNav";

function InnerApp() {
  const contentRef = useRef(null);
  const currentURL = window.location.pathname.toLowerCase();
  const isOnLookingToDoPage =
    currentURL === AppRoutes.LOOKING_TO_DO_PAGE.toLowerCase();
  const isOnPurchaseComparePage =
    currentURL === AppRoutes.PURCHASE_IRQ_COMPARE_PAGE.toLowerCase();
  const isOnBuildComparePage =
    currentURL === AppRoutes.BUILD_IRQ_COMPARE_PAGE.toLowerCase();
  const isOnFastTrackPage =
    currentURL ===
    (process.env.REACT_APP_ROUTE_PREFIX + "/fasttrack").toLowerCase();
  const isOnRefinanceComparePage = new RegExp(
    `^${AppRoutes.REFINANCE_IRQ_COMPARE_PAGE.replace("/:id", "/\\w+$")}`,
    "i"
  ).test(currentURL.toLowerCase());
  const mainOutletWrapperClassName =
    isOnPurchaseComparePage ||
    isOnBuildComparePage ||
    isOnFastTrackPage ||
    isOnRefinanceComparePage
      ? "compare-page-app-wrapper"
      : "app-content-wrapper adjust-height";
  const isNotSupportedPage =
    currentURL.startsWith(
      AppRoutes.PURCHASE_IRQ_NOT_SUPPORTED_PAGE.toLowerCase()
    ) ||
    currentURL.startsWith(
      AppRoutes.BUILD_IRQ_NOT_SUPPORTED_PAGE.toLowerCase()
    ) ||
    currentURL.startsWith(
      AppRoutes.REFINANCE_IRQ_NOT_SUPPORTED_PAGE.toLowerCase()
    );

  return (
    <div>
      <CustomNav contentRef={contentRef} />
      <div ref={contentRef} className={mainOutletWrapperClassName}>
        <Outlet />
        {isOnLookingToDoPage ||
        isOnPurchaseComparePage ||
        isOnRefinanceComparePage ||
        isOnBuildComparePage ||
        isOnFastTrackPage ? null : (
          <>
            <div className="inner-app-back-button-wrapper">
              <BackButton />
            </div>
            {!isNotSupportedPage && (
              <div className="inner-app-next-button-wrapper">
                <NextButton />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default InnerApp;
